import { History, Location, LocationState } from 'history'
import { action, makeObservable, observable } from 'mobx'

import { setRoutingStore } from './routingStore'

export class RouterStore {
  location: Location
  history: History

  constructor(history: History) {
    this.history = history
    this.location = history.location

    makeObservable(this, {
      location: observable,
      _updateLocation: action.bound,
      push: action.bound,
      replace: action.bound,
    })

    history.listen(this._updateLocation)

    // Registers itself so computedRouteParam & friends can reach the active
    // store without importing the app's singleton (which would be circular).
    // The last constructed instance wins; setRoutingStore() can still override
    // it explicitly (e.g. with a mock in tests).
    setRoutingStore(this)
  }

  _updateLocation(newState: Location) {
    this.location = newState
  }

  /*
   * History methods
   */
  push = (location: Location, state: LocationState) => {
    this.history.push(location, state)
  }

  replace = (location: Location, state: LocationState) => {
    this.history.replace(location, state)
  }
}
